export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_day_392.0c47b313.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};